import React from 'react';
import { Link } from 'react-router-dom';
// Components
import BabyForm from '../forms/BabyForm';
import { CONTACT_PAGE_URL } from '../../utils/Routes';

function BabyFormMainContainer() {
  return (
    <main role='main' className='grid w-full h-full pb-12'>
      {/* Form section */}
      <section className='grid w-full'>
        <div className='grid w-full gap-y-12 px-6 lg:container lg:mx-auto pt-12'>
          {/* Intro Text */}
          <div className='max-w-3xl mx-auto text-sm lg:text-base leading-relaxed space-y-4 text-center'>
            <p className='text-lg lg:text-2xl font-bold text-colour6'>
              Ready for Nanny M’s care?
            </p>
            <p>
              Whether you're a shy little, an excitable toddler, or a curious
              nappy diaper lover exploring your softer side, you're safe here.
              Nanny M creates a warm, comforting space where you can let go,
              regress, and feel truly seen.
            </p>
            <p>
              I offer structured nursery sessions tailored to your needs — from
              nurturing and gentle cuddles, to strict naptime rules, feeding,
              changing, and creative age play scenarios. I take pride in helping
              you feel little, safe, and cherished.
            </p>
            <p>
              Every baby is different — some need strict routines, others just
              need a quiet space to play. You’ll let me know your needs below,
              and I’ll see if I have a special place for you in my nursery.
            </p>
          </div>

          {/* Form */}
          <BabyForm />
        </div>
      </section>

      {/* Tribute Rates Section */}
      <section className='grid w-full px-6 pt-12'>
        <div className='grid px-8 mx-auto py-8 gap-y-4 w-full min-w-xl max-w-3xl text-center text-colour2'>
          <h3 className='text-4xl lg:text-5xl font-titleFont text-colour6 font-semibold'>
            Tribute Rates
          </h3>
          <p className='text-sm lg:text-base leading-relaxed'>
            Sessions start from just <strong>£175</strong>. Tribute rates vary
            depending on the type, length, and intensity of the session, as well
            as any special requests.
          </p>
          <p className='text-sm lg:text-base leading-relaxed'>
            Contact me directly to discuss your ideal session and receive a
            personalized quote.
          </p>
          <div className='grid w-fit mx-auto mt-4'>
            <Link
              href={CONTACT_PAGE_URL}
              title='Contact me link'
              className='bg-colour6 hover:brightness-110 text-colour1 text-sm font-serif px-6 py-2 border-2 border-colour2 uppercase'
              aria-label='Enquire about tribute rates with Mistress Maria'
            >
              Contact Me
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}

export default BabyFormMainContainer;
